import { IsPC } from "./isPc"; // 你的 IsPC 放这里

export const applyClientClass = () => {
  if (typeof document === "undefined") return;

  const root = document.documentElement; // <html>
  const isPc = IsPC();

  root.classList.toggle("is-pc", isPc);
  root.classList.toggle("is-mobile", !isPc);
};
